import styled from 'styled-components';

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.75rem 0;
  width: min(560px, 78vw);
  color: ${(props) => props.theme.colors.onSurface};

  .input { width: 100%; box-sizing: border-box; }

  @media (max-width: 620px) { width: 100%; }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 0.4rem;
  font-weight: 600;
`;

export const HelpText = styled.p`
  margin: 0.4rem 0 0;
  font-size: 0.85rem;
`;

export const AudienceRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.7rem;
  @media (max-width: 620px) { flex-direction: column; align-items: stretch; }
`;

export const AudienceField = styled.div`
  flex: 1;
  min-width: 0;
`;
